import styled from 'styled-components'

export const Wrapper = styled.footer`
  background-color: ${({ theme: { colors } }) => colors.darkGray};
  padding: 3rem 10vw 0.3rem;
`
export const FooterUpper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (max-width: 600px) {
    gap: 0.5rem;
  }
  @media (min-width: 600px) {
    gap: 2rem;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  @media (min-width: 850px) {
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
  }
`
export const ReservedRights = styled.p`
  margin: 0;
  font-size: 0.7rem;

  @media (max-width: 600px) {
    font-size: 0.65rem;
  }
`
export const FooterBottom = styled.div`
  text-align: center;
  color: ${({ theme: { colors } }) => colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.6rem;
  font-weight: 550;
  & > ${ReservedRights} {
    color: ${({ theme: { colors } }) => colors.primary};
  }
  svg {
    height: 1rem;
    margin: 0 0.5rem;
  }
  @media (min-width: 600px) and (max-width: 850px) {
    margin-top: 2rem;
  }
  @media (max-width: 382px) {
    flex-direction: column;
    margin-top: 1rem;
  }
`

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1024px) {
    flex: 1;
    margin: 0;
  }
`
export const SocialIconsContainer = styled.div`
  display: flex;
  align-items: center;
  > svg {
    margin: 0 1rem;
  }
  padding-bottom: 0.6rem;
  border-bottom: 2px solid ${({ theme: { colors } }) => colors.primary};
`
export const SocialLink = styled.a`
  margin: 0 0.3rem;
  > svg {
    height: 25px;
    fill: ${({ theme: { colors } }) => colors.white};
    transition: fill 0.3s;
  }
  :hover {
    > svg {
      fill: ${({ theme: { colors } }) => colors.primary};
    }
  }
`
export const SocialText = styled.p`
  margin: 0;
  color: ${({ theme: { colors } }) => colors.white};
`

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 850px) {
    text-align: center;
    padding-bottom: 1rem;
  }
`

export const Logo = styled.div`
  height: 3.5rem;
  > svg {
    width: 10rem;
  }
`

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 850px) {
    padding: 0 !important;
  }
`
export const FooterLink = styled.a`
  text-decoration: none;
  padding-bottom: 0.6rem;
  color: ${({ theme: { colors } }) => colors.white};
  font-size: 0.85rem;
  transition: color 0.4s;
  cursor: pointer;
  :hover {
    color: ${({ theme: { colors } }) => colors.primary};
  }

  @media (max-width: 850px) {
    align-self: center !important;
  }
`

export const SubscribeContainer = styled.div`
  @media (max-width: 850px) {
    align-self: center !important;
  }
`
export const SubmitContainer = styled.form`
  display: flex;
  flex-direction: row;
  height: 4rem;

  @media (max-width: 850px) {
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 0rem;
  }
`

export const SubscribeLabel = styled.label`
  font-size: ${({ theme: { fontSizes } }) => fontSizes.small};
  color: ${({ theme: { colors } }) => colors.white};

  @media (min-width: 650px) and (max-width: 850px) {
    margin: 0 1rem;
    display: block;
    text-align: center;
  }
  @media (max-width: 650px) {
    margin: 0 0.8rem;
    display: block;
    text-align: center;
  }
  @media (max-width: 599px) {
    margin: 0 1.5rem;
  }
`

export const SubscribeInput = styled.input`
  padding: 0.4rem 0.4rem;
  width: 11rem;
  height: 2rem;
  align-self: center;
  border-radius: 0.3rem;
  border: 1px solid ${({ theme: { colors } }) => colors.primary};
  border-color: ${({ theme: { colors } }) => colors.lighterGreen};
  background-color: ${({ theme: { colors } }) => colors.darkGray};
  color: ${({ theme: { colors } }) => colors.white};
  font-weight: 100;
  :focus {
    outline: none;
    font-size: ${({ theme: { fontSizes } }) => fontSizes.small};
    box-shadow: 0px 0px 8px ${({ theme: { colors } }) => colors.primary};
  }
  ::placeholder {
    color: ${({ theme: { colors } }) => colors.white};
    font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  }

  @media (max-width: 600px) {
    margin: 0;
  }
  @media (max-width: 818px) {
    margin: 0.5rem 0 0;
  }
`

export const ErrorField = styled.div`
  margin: 0;
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  color: ${({ theme: { colors } }) => colors.red3};

  @media (max-width: 398px) {
    text-align: center;
    margin-top: 2rem;
  }
  @media (max-width: 820px) and (min-width: 601px) {
    text-align: center;
    margin-top: 2rem;
  }
  @media (max-width: 600px) and (min-width: 400px) {
    text-align: center;
    margin-top: 0;
  }
`

export const Feedback = styled.a`
  display: flex;
  font-size: 0.75rem;
  text-decoration: none;
  color: ${({ theme: { colors } }) => colors.white};
  transition: 0.3s;
  align-items: center;
  margin: 0.7rem 0;
  margin-bottom: 3rem;
  > svg {
    margin-right: 0.5rem;
    fill: ${({ theme: { colors } }) => colors.gray};
    min-width: 18px;
    width: 0.75rem;
  }

  :hover {
    color: ${({ theme: { colors } }) => colors.primary};
    > svg {
      fill: ${({ theme: { colors } }) => colors.primary};
    }
  }
  @media (min-width: 768px) {
    padding: 0.6rem 0;
    margin-bottom: 0.7rem;
  }
`
